<section class="rs-es-first-section">
  <mprd-back-link></mprd-back-link>
  <div class="row">
    <div class="columns small-12">
      <h1 class="rs-tit1-sp rs-txt-c2 rs-has-subtit">
        {{ "sim.replace-sim" | translate }}
      </h1>
      <p class="rs-txt-s5 rs-txt-c2" x-ms-format-detection="none">
        <mprd-access-number-formatter
          plc="MV"
          [accessNumber]="msisdn"
        ></mprd-access-number-formatter>
      </p>
      <div class="rs-panel-big rs-bg-c2 clearfix">
        <h2>
          {{ "sim.replace-sim.subtitle" | translate }}
        </h2>
        <div class="rs-entrypoint-container">
          <div class="rs-flex-row" role="list">
            <div
              *ngIf="('eshare.esim.enable' | translate) !== 'false'"
              class="rs-flex-columns small-12 medium-4"
              role="listitem"
            >
              <button class="rs-entrypoint" (click)="onReplaceWithEsim()">
                <i
                  class="icon-Network icon-lh rs-entrypoint-icon"
                  aria-hidden="true"
                ></i>
                <span class="rs-entrypoint-title">
                  {{ "sim.replace-sim.esim" | translate }}
                </span>
                <span class="rs-entrypoints-txt">
                  {{ "sim.replace-sim.esim-description" | translate }}
                </span>
                <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
              </button>
            </div>
            <div class="rs-flex-columns small-12 medium-4" role="listitem">
              <a routerLink="physical" class="rs-entrypoint">
                <i
                  class="icon-MicroSIM-card icon-lh rs-entrypoint-icon"
                  aria-hidden="true"
                ></i>
                <span class="rs-entrypoint-title">
                  {{ "sim.replace-sim.sim" | translate }}
                </span>
                <span class="rs-entrypoints-txt">
                  {{ "sim.replace-sim.sim-description" | translate }}
                </span>
                <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="rs-le2"></div>
    </div>
  </div>
</section>
